import styled from 'styled-components';
import React from 'react';
import theme from '../../styles/theme';

const SubTitleStyle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;

  p {
    color: ${({ theme }) => theme.colors.gray};
    font-family: 'Lato', sans-serif;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0;
    margin: 0;
    opacity: 0.5;
  }

  span {
    color: ${(props) => subTitleColor(props)};
    background: ${({ theme }) => `${theme.colors.white} 0% 0% no-repeat padding-box`};
    background: ${({ theme }) => `${theme.colors.white} 0% 0% no-repeat padding-box`};
    font-family: 'Lato', sans-serif;
    padding: 6px 12px;
    box-shadow: 0px 3px 6px #0000001c;
    align-self: flex-end;
    border-radius: 40px;
  }
`;

const subTitleColor = ({ category }) =>
  ({
    'E-commerce': theme.colors.yellow,
    'Venda Mais': theme.colors.orange,
    'Pagar.me News': theme.colors.green,
    'História de Sucesso': theme.colors.purple,
    default: theme.colors.green,
  }[category || 'default']);

const SubTitle = (props) => <SubTitleStyle {...props}>{props.children}</SubTitleStyle>;

export default SubTitle;
